import { serviceWizardSearchRequestService } from '../services/api/serviceWizardSearchRequestService';
import {
  fingerprintWizardState,
  getOrCreateWizardClientSessionId,
  getPersistedWizardSearchRequestId,
  setPersistedWizardSearchRequestId,
} from './wizardClientSession';

/**
 * Create (or reuse) the active wizard search request and bind its id to this browser tab.
 * Guests send `clientSessionId` so Cosmos ownership matches the tab. Signed-in creates are
 * account-owned via the auth cookie; `clientSessionId` is ignored for ownership.
 *
 * Always writes the request id to `sessionStorage` when create succeeds, even if the caller
 * unmounts afterward — so storefront / provider pages can rehydrate after navigation.
 *
 * @param {{ serviceType?: string, subServiceType?: string | null, formData?: object, requestSummary?: unknown, inquiryKind?: string, targetSubServiceType?: string | null, targetServiceTitle?: string | null } | null | undefined} wizardState
 * @returns {Promise<string | null>} persisted request id
 */
export async function persistActiveWizardSearchRequest(wizardState) {
  if (!wizardState?.formData || !wizardState?.serviceType) return null;

  const fp = fingerprintWizardState(wizardState);
  const existing = getPersistedWizardSearchRequestId(fp);
  if (existing) return existing;

  const payload = {
    serviceType: wizardState.serviceType,
    subServiceType: wizardState.subServiceType ?? null,
    formData: wizardState.formData,
    requestSummary: wizardState.requestSummary,
    clientSessionId: getOrCreateWizardClientSessionId(),
  };
  if (wizardState.inquiryKind) payload.inquiryKind = wizardState.inquiryKind;
  if (wizardState.targetSubServiceType != null) {
    payload.targetSubServiceType = wizardState.targetSubServiceType;
  }
  if (wizardState.targetServiceTitle != null) {
    payload.targetServiceTitle = wizardState.targetServiceTitle;
  }

  const res = await serviceWizardSearchRequestService.create(payload);
  if (!res?.id) return null;
  setPersistedWizardSearchRequestId(res.id, fp);
  return res.id;
}
